import { useMemo } from 'react';
import styled, { createGlobalStyle } from 'styled-components';

import { DoubleColumnLayout } from '~/src/components/DoubleColumnLayout';
import { useContextSelector } from '~/src/entities/speed-bonus/context/hooks';

import SummaryInfo from './containers/SummaryInfo';
import RoutersPage from './pages/routers';
import TimeSlotsPage from './pages/time-slots';

const GlobalStyle = createGlobalStyle`
    button[data-test="chat-btn"] {
        display: none;
    }
`;

const steps = [RoutersPage, TimeSlotsPage] as const;

const Connection = ({ className }: { className?: string }): JSX.Element => {
    const stepIndex = useContextSelector(state => state.stepIndex);

    const CurrentStep = useMemo(() => steps[stepIndex], [stepIndex]);

    return (
        <>
            <GlobalStyle/>
            <DoubleColumnLayout className={className}>
                <CurrentStep/>
                <SummaryInfo/>
            </DoubleColumnLayout>
        </>
    );
};

export default styled(Connection)`
    margin-top: 32px;
`;
